export default __webpack_public_path__ + "static/media/gallery 8.1e2735ca.png";